import React, { useState, useCallback, useEffect } from "react";
import Tabs, { Tab } from "components/Nav/Tabs";
import classNames from "classnames";
import useSelector from "hooks/useSelector";
import AnnualClockContainer, { Position } from "./AnnualClockContainer";
import { AnnualClockCategory } from "api-client";
import { useIntl } from "react-intl";
import { useFeatureFlags } from "constants/index";
import "./AnnualClock.scss";

const AnnualClock = ({ categories }: { categories: AnnualClockCategory[] }) => {
    const intl = useIntl();
    const { annualClockManagerView } = useFeatureFlags();
    const profile = useSelector((state) => state.user.profile.data);
    const [selectedAnnualClock, setSelectedAnnualClock] = useState(categories[0]["position"]);
    const [position, setPosition] = useState<Position>(Position.Manager);
    const handleAnnualClockChange = useCallback(
        (_: React.MouseEvent<HTMLButtonElement>, annualClock: string) => {
            setSelectedAnnualClock(annualClock);
        },
        [],
    );
    if (!selectedAnnualClock) {
        return null;
    }
    useEffect(() => {
        setPosition(
            selectedAnnualClock === Position.Manager ? Position.Manager : Position.Employee,
        );
    });

    return (
        <div className="AnnualClock">
            <div className="header">
                <div className="title">
                    {intl.formatMessage({
                        id: "annual_clock.title",
                    })}
                </div>
                {profile.isManager || annualClockManagerView ? (
                    <div className="categories">
                        <div className="categories-title">
                            {intl.formatMessage({
                                id: "annual_clock.categories",
                            })}
                        </div>
                        <div className="tabs">
                            <Tabs
                                selectedTab={selectedAnnualClock}
                                handleChange={handleAnnualClockChange}
                            >
                                <Tab
                                    classes={{
                                        root: "position-tab",
                                        button: classNames("manager-button", {
                                            "manager-button--selected":
                                                Position.Manager === selectedAnnualClock,
                                        }),
                                    }}
                                    label={Position.Manager}
                                />
                                <Tab
                                    classes={{
                                        root: "position-tab",
                                        button: classNames("employee-button", {
                                            "employee-button--selected":
                                                Position.Employee === selectedAnnualClock,
                                        }),
                                    }}
                                    label={Position.Employee}
                                />
                            </Tabs>
                        </div>
                    </div>
                ) : null}
            </div>
            {profile.isManager || annualClockManagerView ? (
                categories.map((category, num) => {
                    return (
                        selectedAnnualClock === category.position && (
                            <AnnualClockContainer
                                key={num}
                                quarters={category.quarters}
                                position={position}
                            />
                        )
                    );
                })
            ) : (
                <AnnualClockContainer
                    quarters={categories[1]["quarters"]}
                    position={Position.Employee}
                />
            )}
            <div className="info">
                {intl.formatMessage({
                    id: "annual_clock.info",
                })}
            </div>
        </div>
    );
};
export default AnnualClock;
